import React from 'react';

const TriangleSearchSm = ({className}) => (
  <svg className={className} viewBox="0 0 38 23" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M37.8926 0L24.8149 18.8917C24.4414 19.4314 24.0239 19.943 23.548 20.395C19.9776 23.7859 18.0182 23.7813 14.4551 20.3848C13.9778 19.9298 13.5596 19.415 13.1858 18.8719L0.196289 0H37.8926Z"/>
  </svg>
);

export default TriangleSearchSm;
